module.exports = __webpack_public_path__ + "img/c02_unittriremechampion_Normal_ua.053fd320.webp";